import { API_VERSION, SERVER } from '@/services';
import { request } from 'umi';

type ThemeConfigItem = { content: { [key: string]: any } };

// type: 20平台设置 30关于我们 40联系我们 50注册登录 60其他照片
export function getConfiguration(type: number) {
  return request<ThemeConfigItem>(`/${SERVER.foundation}/${API_VERSION}/im/getConfig`, {
    method: 'GET',
    params: { type },
    useCache: true,
    useAuth: false,
  });
}
